interface ReportLoaderProps {
  message?: string;
}

export function ReportLoader({ message = 'Retrieving report...' }: ReportLoaderProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-8">
      <div className="relative h-36 w-36">
        {/* Outer ring — CCT Green */}
        <div className="absolute inset-0 rounded-full border-[calc(--spacing(1.5))] border-transparent border-t-primary border-r-primary animate-[orbital-cw_1.4s_linear_infinite]" />
        {/* Middle ring — CCT Blue */}
        <div className="absolute inset-5 rounded-full border-[calc(--spacing(1.5))] border-transparent border-t-accent border-r-accent animate-[orbital-ccw_1s_linear_infinite]" />
        {/* Inner ring — CCT Purple */}
        <div className="absolute inset-10 rounded-full border-[calc(--spacing(1.5))] border-transparent border-t-highlight border-r-highlight animate-[orbital-cw_0.7s_linear_infinite]" />
      </div>

      <p className="animate-[fade-pulse_2s_ease-in-out_infinite] text-sm text-muted-foreground">
        {message}
      </p>
    </div>
  );
}
